import React from 'react';
import styles from '@dazn/lp-web/src/components/Benefits/benefits.module.css';
import {IBenefits, IBenefit} from '@dazn/lp-web/src/types/benefits.types';
import {deviceDetector} from '@dazn/lp-web/src/utils/deviceDetector';
import {useLandingPagesContext} from '../../contexts/LandingPageContext';
import {checkIsTravelPassEnabled} from '../../features/getIsTravelPassEnable';
import classNames from 'classnames';
import { getButtonItemId } from '../../proxies';
import { triggerElementClick } from '../../analytics/fe-events';
import { elementClickEventTypes } from '../../analytics/fe-events/elementClick';

interface BenefitsProps {
    data: IBenefits;
    disableAnimation?: boolean;
}

interface BenefitCardProps {
    benefit: IBenefit;
}

const Benefits: React.FC<BenefitsProps> = ({data}) => {
    const {getPromoCodeByEntSetId} = useLandingPagesContext();
    const {title, benefits = [], button} = data;
    let buttonLabel = button.label;
    if (deviceDetector.isMobileDevice) {
        buttonLabel = button.mobileButtonLabel ?? button.label;
    }

    const entSetId = button?.entitlementSetId;
    const promoCode = getPromoCodeByEntSetId(entSetId);

    return (
        <div
            className={classNames(styles.benefitsWrapper, {
                [styles.benefitsWrapperThemeDark]: checkIsTravelPassEnabled()
            })}
        >
            {title && (
                <div
                    className={classNames(styles.title, {
                        [styles.titleTravelPass]: checkIsTravelPassEnabled()
                    })}
                >
                    {title}
                </div>
            )}
            <div className={styles.benefits}>
                {benefits.map((benefit: IBenefit, index: number) => (
                    <BenefitCard key={index} benefit={benefit} />
                ))}
            </div>
            <div className={styles.buttonWrapper}>
                {buttonLabel && (
                    <button
                        className={classNames(styles.button, {
                            [styles.buttonTravelPass]:
                                checkIsTravelPassEnabled()
                        })}
                        onClick={() => {
                            const buttonItemId =
                                getButtonItemId(button) || '';
                            triggerElementClick({
                                section:
                                    elementClickEventTypes.BODY,
                                itemId: buttonItemId,
                                resourceString: button.label
                            });
                            button.action({promoCode});
                        }}

                    >
                        {buttonLabel}
                    </button>
                )}
            </div>
        </div>
    );
};

const BenefitCard: React.FC<BenefitCardProps> = React.memo(({benefit}) => {
    const {logo, title, description} = benefit || {};

    return (
        <div
            className={classNames(styles.benefitCard, {
                [styles.benefitCardTravelPass]: checkIsTravelPassEnabled()
            })}
        >
            <div className={styles.iconsContainer}>
                <div className={styles.icon}>
                    {logo?.src && (
                        <img src={logo.src} alt={title || 'Feature Icon'} />
                    )}
                </div>
            </div>
            <div className={styles.copyContainer}>
                {title && (
                    <div
                        className={classNames(styles.cardTitle, {
                            [styles.cardTitleTravelPass]:
                                checkIsTravelPassEnabled()
                        })}
                    >
                        {title}
                    </div>
                )}
                {description && (
                    <div
                        className={classNames(styles.cardDescription, {
                            [styles.cardDescriptionTravelPass]:
                                checkIsTravelPassEnabled()
                        })}
                    >
                        {description}
                    </div>
                )}
            </div>
        </div>
    );
});

export default Benefits;
